<ng-container [formGroup]="form">
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">Upload document</h5>
  </div>

  <div class="modal-body container" ngbAutofocus>
    <div class="form-row">
      <div class="form-group col-2 type">
        <app-dc-select
          formControlName="type"
          [labelId]="'type'"
          label="File Type"
          [items]="types"
          closeOnSelect="true"
          [searchable]="true"
          [FreeText]="true"
        ></app-dc-select>
      </div>
      <div class="form-group col-2 language">
        <app-dc-select
          formControlName="language"
          [labelId]="'language'"
          label="Language"
          [items]="languages"
          closeOnSelect="true"
        ></app-dc-select>
      </div>
      <div class="form-group col-2 documentState">
        <app-dc-select
          formControlName="documentState"
          [labelId]="'documentState'"
          label="Select document type"
          [items]="documentStateItems"
          closeOnSelect="true"
        >
        </app-dc-select>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col file">
        <app-dc-file-upload
          (fileLoaded)="handleFile($event)"
          [allowMultipleFiles]="false"
        ></app-dc-file-upload>
      </div>
    </div>
  </div>

  <div class="modal-footer justify-content-right">
    <button type="button" class="btn btn-secondary btn-sm" (click)="cancel()">
      Cancel
    </button>
    <button
      type="button"
      [disabled]="form.invalid"
      class="btn btn-primary btn-sm"
      (click)="save()"
    >
      Upload
    </button>
  </div>
</ng-container>
